/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var pdf_export_component_1 = require("./pdf-export.component");
var pdf_export_margin_component_1 = require("./pdf-export-margin.component");
var pdf_export_template_directive_1 = require("./pdf-export-template.directive");
var COMPONENT_DIRECTIVES = [
    pdf_export_component_1.PDFExportComponent,
    pdf_export_margin_component_1.PDFExportMarginComponent,
    pdf_export_template_directive_1.PDFExportTemplateDirective
];
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }}) definition for the PDF Export directive.
 */
var PDFExportModule = /** @class */ (function () {
    function PDFExportModule() {
    }
    PDFExportModule = tslib_1.__decorate([
        core_1.NgModule({
            declarations: [COMPONENT_DIRECTIVES],
            exports: [COMPONENT_DIRECTIVES]
        })
    ], PDFExportModule);
    return PDFExportModule;
}());
exports.PDFExportModule = PDFExportModule;
